var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "message-list"
  }, _vm._l((_vm.messages), function(message) {
    return _c('message', {
      key: message.id,
      class: ("message-" + (message.type)),
      attrs: {
        "message": message
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b8f18d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageList.vue
// module id = 173
// module chunks = 1